<template>
	<el-select
		v-model="code"
		:placeholder="$t('login.area_code')"
		@change="slectArea"
		style="width: 80px"
	>
		<el-option v-for="item in area_code" :key="item.value" :label="item.key" :value="item.value">
			<span>{{ item.key }}</span>
			<span>({{ getLangConfing() === 'zh-cn' ? item.name : item.en_name }})</span>
		</el-option>
	</el-select>
</template>

<script lang="ts" setup>
import { onMounted, ref, watchEffect } from 'vue'
import type { PropType } from 'vue'
import { getAreacode } from '../../api/login'
import type { AreaCode } from '../../types/login'
import { getLangConfing } from '/@/utils/config'

const props = defineProps({
	modelValue: {
		type: String as PropType<string | number>,
		default: '',
	},
})

const emit = defineEmits(['update:modelValue', 'clear'])

const code = ref(props.modelValue)

watchEffect(() => {
	code.value = props.modelValue
})
//获取电话区号
const code_loading = ref(false)
const area_code = ref<AreaCode[]>([])
const get_areacode = async () => {
	const { data } = await getAreacode(code_loading)
	area_code.value = data || []
	if ((data || [])?.length > 0) {
		code.value = (data || [])[0].value
		emit('update:modelValue', code.value)
		emit('clear')
	}
}

const slectArea = (val) => {
	emit('update:modelValue', val)
}
onMounted(() => {
	get_areacode()
})
</script>

<style scoped lang="scss"></style>
